import {useRef, useEffect} from 'react';
import colourspace from 'color-space';


export const usePrevious = (value) => {
	const ref = useRef();
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
};


export const callback = (fn, args) => {
	if (fn && typeof fn === 'function') {
		fn(...args);
	}
};

export const hex2rgb = (str) => {
	let s = str.replace('#', '');
	if (s.length == 3) {
		return s.split().map((a)=>parseInt(a, 16));
	} else {
		return s.match(/.{1,2}/g).map((a)=>parseInt(a, 16));
	}
}

export const rgb2hex = (colour) => {
	return '#' + colour.map((a)=>('0' + Math.max(0, Math.min(255, Math.round(a))).toString(16)).slice(-2)).join('');
}


function changeBrightness(colour, percent) {
	let hsv = colourspace.rgb.hsv(hex2rgb(colour));
	hsv[2] = Math.min(100, Math.max(0, hsv[2]*(1+percent)));
	return rgb2hex(colourspace.hsv.rgb(hsv));
}

export const brighten = (colour, percent) => {
	return changeBrightness(colour, percent);
}

export const darken = (colour, percent) => {
	return changeBrightness(colour, -percent);
}


export const stringColour = (str, basebrightness = 70) => {
	let sum = 0;
	str = str.toLowerCase();
	for(let i=0; i < str.length; i++) {
		sum += str.charCodeAt(i);
	}
	return rgb2hex(colourspace.hsl.rgb((sum % 180)*2, 100, basebrightness));
}


export const stringBrightness = (colour, str) => {
	let sum = 0;
	str = str.toLowerCase();
	for(let i=0; i < str.length; i++) {
		sum += str.charCodeAt(i);
	}
	let c = colourspace.rgb.hsl(hex2rgb(colour));
	c[2] = 50; // Bring it down to average brightness
	const range = 50; // It should go from 25 to 75
	c[2] += (sum % range) - (range/2);
	return rgb2hex(colourspace.hsl.rgb(c));
}




export const parseNumber = (num) => {
	const str = num.toString().replace(/(\$|,)/g, '')
	const n = parseFloat(str);
	if (n.toString() == str)
		return str;
	throw new Error(str + ' is not a number');
}

export const parseRaspberryRowText =(text) => {
	let o =''
	let errors = [];
	let chunks = (text || '').split(/[,|\n]/);
	chunks = chunks.map((a)=>a.trim())
	//console.log(chunks);
	chunks = chunks.filter((a)=>{
		return a.trim().length > 0;
	}).map((a)=>{
		let pieces = a.split(/[x\*]/).map((b)=>b.trim());
		if (pieces.length < 2)
			pieces.unshift(1);
		for(let i=0; i < 2; i++) {
			try {
				let n = parseNumber(pieces[i]);
				pieces[i] = n;
			} catch(e) {
				errors.push(e.message);
				console.log("error", e);
			}
		}
		return [pieces[0], pieces[1]];
	});
	//console.log(chunks);
	return {'errors': errors, 'data': chunks};
}